import React, { Fragment } from 'react';
import { endpoints } from 'Core/defaultValues';
import { useIntl } from 'react-intl';
import { Grid, Typography  } from '@mui/material';
import { getEventColor } from '../../utils';

import './style.scss'

/** Inline SVG matching the WebGL vehicle arrow marker */
const VehicleArrowIcon = ({ color = '#000' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style={{ display: 'block' }}>
    <path
      d="M 12.11,2.48 C 12.11,2.48 4.61,20.77 4.61,20.77 4.61,20.77 5.32,21.48 5.32,21.48 5.32,21.48 12.11,18.48 12.11,18.48 12.11,18.48 18.90,21.48 18.90,21.48 18.90,21.48 19.61,20.77 19.61,20.77 19.61,20.77 12.11,2.48 12.11,2.48 Z"
      fill={color}
      stroke="#fff"
      strokeWidth="0.8"
    />
  </svg>
);

const PanelEtaLink = (props) => {

  const { pointers, etaLabel } = props

  const pathFile = `https://s3.amazonaws.com/${endpoints.PUBLIC_REPOSITORY_CODE}`

  // Derive vehicle marker color from eventName, matching the map marker
  const vehiclePointer = pointers?.[0];
  const vehicleColor = getEventColor(vehiclePointer?.eventName);

  return (
    <Fragment>
      <div className="panel-eta-container">
        <Grid
          container
          direction="row"
          wrap="nowrap"
          justifyContent="flex-start"
          alignItems="top"
          spacing={1}
        >
          <Grid item>
            <VehicleArrowIcon color={vehicleColor} />
          </Grid>
          <Grid item xs>
            <Typography style={{ textAlign: 'left' }}>{pointers && pointers.length > 0 && pointers[0].label || ''}</Typography>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="top"
          spacing={1}
        >
          <Grid item>
            <img style={{ position: 'relative', width: 24, height: 24, marginTop: 1 }} alt="end "src={`${pathFile}/icons/maps/place/018759.png`} />
          </Grid>
          <Grid item xs>
            <Typography style={{ textAlign: 'left' }}>{pointers && pointers.length > 1 && pointers[1].label || ''}</Typography>
          </Grid>
        </Grid>
      { etaLabel 
      &&
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="top"
          spacing={1}
        >
          <Grid item style={{ paddingTop: 10 }}>
            {etaLabel}
          </Grid>
        </Grid>
      }
      </div>
    </Fragment>
  )
}

export default PanelEtaLink;